<div class="row mb-10">
  <!-- header title -->
  <div class="col-md-12">
     <h2> shared</h2>
  </div>
  <!-- All Buttons and fileds -->
  <div class="col-md-2"> <button class="rt-btn rt-add"><span class="material-icons">
     delete
     </span> Delete</button>
  </div>
  <div class="col-md-3">
     <div class="rt-search">
        <form role="search" class="search-form form">
           <label>
           <span class="screen-reader-text">Search for...</span>
           <input type="search" class="search-field" placeholder="Type something..." value="" name="s" title="" />
           </label>
           <button type="submit" class="search-submit s-btn">
           <span class="material-icons">
           search
           </span>
           </button>
        </form>
     </div>
  </div>
  <div class="col-md-3">
     <div class="form__group field">
        <input type="filter" class="form__field"  name="filter" id='filter' required />
        <label for="name" class="form__label">Filter</label>
     </div>
  </div>
  <div class="col-md-3">
     <div class="form__group field">
        <input type="search" class="form__field" placeholder="Search" name="search" id='search' required />
        <label for="name" class="form__label">Search</label>
     </div>
  </div>
  <div class="col-md-4 right-btn"><button class="rt-btn rt-add">Assign VLE</button>
     <button class="rt-btn rt-add"> <span class="material-icons">
     exit_to_app
     </span> Export</button>
  </div>
</div>

<!-- dropdown filter -->
<!-- <div class="d-inline-block" ngbDropdown #myDrop="ngbDropdown">
   <button class="btn btn-outline-primary mr-2" id="dropdownManual" ngbDropdownAnchor (focus)="myDrop.open()">Toggle dropdown</button>
   <div ngbDropdownMenu aria-labelledby="dropdownManual">
     <button ngbDropdownItem>Action - 1</button>
     <button ngbDropdownItem>Another Action</button>
     <button ngbDropdownItem>Something else is here</button>
   </div>
 </div> -->



 <div class="rt-dropdown">
  <a class="rt-btn dropdown-toggle" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    Dropdown link
    <span class="material-icons">
     keyboard_arrow_down
     </span>
  </a>

  <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
    <a class="dropdown-item" href="#">Action</a>
    <a class="dropdown-item" href="#">Another action</a>
    <a class="dropdown-item" href="#">Something else here</a>
  </div>
</div> 
<!-- Table -->
<ng-container>
  <div class="rt-td-card">
     <table class="rt-table">
        <thead>
           <tr>
              <th class="checkbox">
                 <label>
                 <input type="checkbox">
                 </label>
              </th>
              <th>Customer ID</th>
              <th>Name</th>
              <th>VLEs Name</th>
              <th>Taluka</th>
              <th>Phone</th>
              <th>Disable/Enable</th>
              <th>Action</th>
           </tr>
        </thead>
        <tbody>
           <tr>
              <td class="checkbox"><label>
                 <input type="checkbox">
                 </label>
              </td>
              <td>Name</td>
              <td>Age</td>
              <td>Date</td>
              <td>Status</td>
              <td>Action</td>
              <td>
                 <label class="switch">
                 <input type="checkbox" checked>
                 <span class="slider round"></span>
                 </label>
              </td>
              <td>
               <button class="rt-icon"><span class="material-icons">
                  edit
                  </span></button>
                  <button class="rt-icon"><span class="material-icons dl-btn">
                   delete
                   </span></button>
              </td>
           </tr>
           <tr>
              <td class="checkbox"><label>
                 <input type="checkbox">
                 </label>
              </td>
              <td>Name</td>
              <td>Age</td>
              <td>Date</td>
              <td>Status</td>
              <td>Action</td>
              <td>
                 <label class="switch">
                 <input type="checkbox" checked>
                 <span class="slider round"></span>
                 </label>
              </td>
              <td>
               <button class="rt-icon"><span class="material-icons">
                  edit
                  </span></button>
                  <button class="rt-icon"><span class="material-icons dl-btn">
                   delete
                   </span></button>
              </td>
           </tr>
           <tr>
              <td class="checkbox"><label>
                 <input type="checkbox">
                 </label>
              </td>
              <td>Name</td>
              <td>Age</td>
              <td>Date</td>
              <td>Status</td>
              <td>Action</td>
              <td>
                 <label class="switch">
                 <input type="checkbox" checked>
                 <span class="slider round"></span>
                 </label>
              </td>
              <td>
                             
                 <button class="rt-icon"><span class="material-icons">
                 edit
                 </span></button>
                 <button class="rt-icon"><span class="material-icons dl-btn">
                  delete
                  </span></button>
              </td>
           </tr>
        </tbody>
     </table>
     <!-- pagination elements starts-->
     <div class="rt-table-pagination">
        <div class="dataTables_length" id="datatable_length">
            <label>
              <span>Rows per page:</span>
              <select
                 class="browser-default">
                 <option value="10">10</option>
                 <option value="20">20</option>
                 <option value="30">30</option>
                 <option value="40">40</option>
                 <option value="50">50</option>
                 <option value="-1">All</option>
              </select>
           </label>
        </div>
        <div class="dataTables_info" id="datatable_info" role="status" aria-live="polite">1 -10 of 100</div>
        <div class="dataTables_paginate paging_simple_numbers" id="datatable_paginate">
           <ul class="material-pagination">
              <li class="paginate_button previous disabled" id="datatable_previous"><a href="#" aria-controls="datatable"
                 data-dt-idx="0" tabindex="0"><i class="material-icons">chevron_left</i></a></li>
              <li class="paginate_button next" id="datatable_next"><a href="#" aria-controls="datatable" data-dt-idx="1"
                 tabindex="0"><i class="material-icons">chevron_right</i></a></li>
           </ul>
        </div>
     </div>
      <!-- pagination elements ends -->
  </div>
</ng-container>